export const campaignKeys = {
  all: ['campaigns'] as const,
  list: () => [...campaignKeys.all, 'list'] as const,
  // `userId` absent means the reader's own count; an admin asks about someone
  // else, and the two must not share a cache entry.
  count: (userId?: string) =>
    userId === undefined
      ? ([...campaignKeys.all, 'count'] as const)
      : ([...campaignKeys.all, 'count', userId] as const),
  detail: (id: string) => [...campaignKeys.all, 'detail', id] as const,
  sources: (id: string) => [...campaignKeys.all, 'sources', id] as const,
  filters: (id: string) => [...campaignKeys.all, 'filters', id] as const,
  // The window is part of the key: the totals are only the totals *of a
  // period*, and switching period must fetch rather than invalidate the cache.
  report: (id: string, range: { from: string; to: string; granularity?: string }) =>
    [...campaignKeys.all, 'report', id, range] as const,
}
